(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["etchedworks-awards-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const refreshGiftImages = () => {
    document.querySelectorAll('#ew-awards-landing .ew-tile[data-gift-image-pool]').forEach(card => {
      if (card.dataset.giftRandomized) return;
      card.dataset.giftRandomized = 'true';
      let pool;
      try { pool = JSON.parse(card.dataset.giftImagePool); } catch { return; }
      if (!pool.length) return;
      const image = card.querySelector('img');
      if (!image) return;
      const key = 'ew-gift-image:' + card.dataset.giftCollection;
      let previous;
      try { previous = localStorage.getItem(key); } catch {}
      const alternatives = pool.filter(product => product.handle !== previous);
      const choices = alternatives.length ? alternatives : pool;
      const chosen = choices[Math.floor(Math.random() * choices.length)];
      const preview = new Image();
      preview.onload = () => {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = chosen.src;
        image.alt = chosen.title;
        card.dataset.giftSelected = chosen.handle;
        try { localStorage.setItem(key, chosen.handle); } catch {}
      };
      preview.src = chosen.src;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshGiftImages, { once: true });
  else refreshGiftImages();
  document.addEventListener('shopify:section:load', refreshGiftImages);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etchedworks-barware-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const refreshGiftImages = () => {
    document.querySelectorAll('#ew-barware-landing .ew-tile[data-gift-image-pool]').forEach(card => {
      if (card.dataset.giftRandomized) return;
      card.dataset.giftRandomized = 'true';
      let pool;
      try { pool = JSON.parse(card.dataset.giftImagePool); } catch { return; }
      if (!pool.length) return;
      const image = card.querySelector('img');
      if (!image) return;
      const key = 'ew-gift-image:' + card.dataset.giftCollection;
      let previous;
      try { previous = localStorage.getItem(key); } catch {}
      const alternatives = pool.filter(product => product.handle !== previous);
      const choices = alternatives.length ? alternatives : pool;
      const chosen = choices[Math.floor(Math.random() * choices.length)];
      const preview = new Image();
      preview.onload = () => {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = chosen.src;
        image.alt = chosen.title;
        card.dataset.giftSelected = chosen.handle;
        try { localStorage.setItem(key, chosen.handle); } catch {}
      };
      preview.src = chosen.src;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshGiftImages, { once: true });
  else refreshGiftImages();
  document.addEventListener('shopify:section:load', refreshGiftImages);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etchedworks-drinkware-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const refreshGiftImages = () => {
    document.querySelectorAll('#ew-drinkware-landing .ew-tile[data-gift-image-pool]').forEach(card => {
      if (card.dataset.giftRandomized) return;
      card.dataset.giftRandomized = 'true';
      let pool;
      try { pool = JSON.parse(card.dataset.giftImagePool); } catch { return; }
      if (!pool.length) return;
      const image = card.querySelector('img');
      if (!image) return;
      const key = 'ew-gift-image:' + card.dataset.giftCollection;
      let previous;
      try { previous = localStorage.getItem(key); } catch {}
      const alternatives = pool.filter(product => product.handle !== previous);
      const choices = alternatives.length ? alternatives : pool;
      const chosen = choices[Math.floor(Math.random() * choices.length)];
      const preview = new Image();
      preview.onload = () => {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = chosen.src;
        image.alt = chosen.title;
        card.dataset.giftSelected = chosen.handle;
        try { localStorage.setItem(key, chosen.handle); } catch {}
      };
      preview.src = chosen.src;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshGiftImages, { once: true });
  else refreshGiftImages();
  document.addEventListener('shopify:section:load', refreshGiftImages);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etchedworks-editorial-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gift-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-gift-track]');
    const viewport = carousel.querySelector('[data-gift-viewport]');
    const seenProducts = new Set();
    Array.from(track.children).forEach((card) => {
      const productId = card.dataset.productId;
      if (seenProducts.has(productId)) card.remove();
      else seenProducts.add(productId);
    });
    const cards = Array.from(track.children);
    for (let index = cards.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
    }
    cards.forEach((card) => track.appendChild(card));

    const advance = (direction) => {
      const card = track.querySelector('.etchedworks-gift-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    carousel.querySelector('[data-gift-previous]').addEventListener('click', () => advance(-1));
    carousel.querySelector('[data-gift-next]').addEventListener('click', () => advance(1));


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etchedworks-featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ew-featured[data-award-rotation]').forEach(section=>{
    const third=section.querySelector('[data-third-award-slider]');
    if(!third)return;
    const region=section.querySelector('.ew-featured__products-region');
    const story=section.querySelector('.ew-featured__story');
    const desktop=window.matchMedia('(min-width:990px)');
    const fit=()=>{region.style.height=desktop.matches?story.getBoundingClientRect().height+'px':'';};
    region.dataset.threeSliders='true';fit();third.hidden=false;
    window.addEventListener('resize',fit);
    new ResizeObserver(fit).observe(story);
  });

  document.querySelectorAll('.ew-featured [data-carousel-group]').forEach((group,index) => {
    const carousel=group.querySelector('[data-product-carousel]');
    const previous=group.querySelector('[data-carousel-previous]');
    const next=group.querySelector('[data-carousel-next]');
    if(!carousel||!previous||!next||group.dataset.ready)return;
    group.dataset.ready='true';
    const automatic=group.closest('[data-award-rotation]');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    if(automatic){
      const cards=Array.from(carousel.children);
      for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]];}
      try{
        const key='ew-award-first:'+group.querySelector('.ew-featured__collection-link').getAttribute('href');
        const last=localStorage.getItem(key);
        if(cards.length>1&&cards[0].querySelector('a').getAttribute('href')===last){[cards[0],cards[1]]=[cards[1],cards[0]];}
        if(cards.length)localStorage.setItem(key,cards[0].querySelector('a').getAttribute('href'));
      }catch(error){}
      carousel.append(...cards);
      carousel.scrollLeft=0;
    }
    const move=(direction)=>{
      const card=carousel.querySelector('.ew-featured__product');
      if(!card)return;
      const distance=card.getBoundingClientRect().width+(parseFloat(getComputedStyle(carousel).gap)||0);
      const end=carousel.scrollWidth-carousel.clientWidth;
      let target=carousel.scrollLeft+distance*direction;
      if(target>end+4)target=0;
      if(target< -4)target=end;
      carousel.scrollTo({left:target,behavior:reduced.matches?'auto':'smooth'});
    };
    let timer,hovered=false,focused=false,visible=false;
    const pause=group.querySelector('[data-carousel-pause]');
    const restart=()=>{
      clearInterval(timer);
      if(!automatic||reduced.matches||hovered||focused||!visible||document.hidden||pause?.getAttribute('aria-pressed')==='true')return;
      timer=setInterval(()=>move(1),8000+(index%3)*2000);
    };
    previous.addEventListener('click',()=>{move(-1);restart();});
    next.addEventListener('click',()=>{move(1);restart();});
    if(!automatic)return;
    group.addEventListener('mouseenter',()=>{hovered=true;restart();});
    group.addEventListener('mouseleave',()=>{hovered=false;restart();});
    group.addEventListener('focusin',()=>{focused=true;restart();});
    group.addEventListener('focusout',()=>{setTimeout(()=>{focused=group.contains(document.activeElement);restart();},0);});
    pause?.addEventListener('click',()=>{const paused=pause.getAttribute('aria-pressed')!=='true';pause.setAttribute('aria-pressed',String(paused));pause.textContent=paused?'Resume':'Pause';restart();});
    document.addEventListener('visibilitychange',restart);
    reduced.addEventListener('change',restart);
    new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;restart();},{threshold:.3}).observe(group);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etchedworks-gifts-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const refreshGiftImages = () => {
    document.querySelectorAll('#ew-gifts-landing .ew-tile[data-gift-image-pool]').forEach(card => {
      if (card.dataset.giftRandomized) return;
      card.dataset.giftRandomized = 'true';
      let pool;
      try { pool = JSON.parse(card.dataset.giftImagePool); } catch { return; }
      if (!pool.length) return;
      const image = card.querySelector('.ew-gift-tile-image img');
      if (!image) return;
      const key = 'ew-gift-image:' + card.dataset.giftCollection;
      let previous;
      try { previous = localStorage.getItem(key); } catch {}
      const alternatives = pool.filter(product => product.handle !== previous);
      const choices = alternatives.length ? alternatives : pool;
      const chosen = choices[Math.floor(Math.random() * choices.length)];
      const preview = new Image();
      preview.onload = () => {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = chosen.src;
        image.alt = chosen.title;
        card.dataset.giftSelected = chosen.handle;
        try { localStorage.setItem(key, chosen.handle); } catch {}
      };
      preview.src = chosen.src;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshGiftImages, { once: true });
  else refreshGiftImages();
  document.addEventListener('shopify:section:load', refreshGiftImages);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etchedworks-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ew-site-header__desktop details').forEach((menu) => {
    if (menu.dataset.ewHoverReady) return;
    menu.dataset.ewHoverReady = 'true';

    let closeTimer;
    let suppressFocusOpen = false;
    const nav = menu.closest('.ew-site-header__desktop');
    const summary = menu.querySelector(':scope > summary');
    const usesHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const overviewLink = menu.parentElement?.classList.contains('ew-site-header__nav-pair') ? menu.previousElementSibling : null;

    const openMenu = () => {
      window.clearTimeout(closeTimer);
      nav?.querySelectorAll('details[open]').forEach((item) => {
        if (item !== menu) item.open = false;
      });
      menu.open = true;
    };

    const closeMenu = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!menu.matches(':hover') && !overviewLink?.matches(':hover') && !menu.querySelector(':scope > div')?.contains(document.activeElement)) {
          menu.open = false;
        }
      }, 160);
    };

     if (menu.classList.contains('ew-site-header__awards-menu') || menu.classList.contains('ew-site-header__drinkware-menu') || menu.classList.contains('ew-site-header__barware-menu') || menu.classList.contains('ew-site-header__bottles-menu') || menu.classList.contains('ew-site-header__gifts-menu') || menu.classList.contains('ew-site-header__division-menu')) {
       overviewLink?.addEventListener('mouseenter', () => {
        if (usesHover.matches) openMenu();
      });
      menu.addEventListener('mouseenter', () => {
        if (usesHover.matches) openMenu();
      });
      overviewLink?.addEventListener('mouseleave', closeMenu);
      menu.addEventListener('mouseleave', closeMenu);
      menu.addEventListener('focusin', () => { if (!suppressFocusOpen) openMenu(); });
      menu.addEventListener('focusout', closeMenu);
      summary?.addEventListener('click', (event) => {
        event.preventDefault();
        if (menu.open) menu.open = false; else openMenu();
      });
      document.addEventListener('click', (event) => {
        if (!menu.contains(event.target) && event.target !== overviewLink) menu.open = false;
      });
    } else {
      menu.addEventListener('mouseenter', () => {
        if (usesHover.matches) openMenu();
      });
      menu.addEventListener('mouseleave', () => {
        if (usesHover.matches) closeMenu();
      });
      menu.addEventListener('focusin', () => { if (!suppressFocusOpen) openMenu(); });
      menu.addEventListener('focusout', closeMenu);
    }
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        suppressFocusOpen = true;
        menu.open = false;
        summary?.focus();
        suppressFocusOpen = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etchedworks-hero-fade"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ew-hero-fade')){
customElements.define('ew-hero-fade',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;
this.ready=true;
this.slides=[...this.querySelectorAll('.ew-hero-fade__slide')];
this.dots=[...this.querySelectorAll('[data-slide]')];
this.toggle=this.querySelector('.ew-hero-fade__pause');
this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;this.hovered=false;this.focused=false;this.visible=true;
this.syncPause();
this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>{this.show(i);this.schedule()}));
this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.syncPause();this.schedule()});
this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule()});
this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule()});
this.addEventListener('focusin',()=>{this.focused=true;this.schedule()});
this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule()})});
this.onVisibility=()=>this.schedule();document.addEventListener('visibilitychange',this.onVisibility);
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule()},{threshold:.1});this.observer.observe(this);
this.schedule();
}
async load(i){
const img=this.slides[i].querySelector('img');
if(img.dataset.src){img.srcset=img.dataset.srcset;img.src=img.dataset.src;delete img.dataset.src;delete img.dataset.srcset}
try{await img.decode();return true}catch{return img.complete&&img.naturalWidth>0}
}
async show(i){
const ticket=this.ticket=(this.ticket||0)+1;
if(!await this.load(i)||ticket!==this.ticket||!this.isConnected)return;
this.index=i;
this.slides.forEach((slide,n)=>{const active=n===i;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.inert=!active;slide.tabIndex=active?0:-1;this.dots[n].setAttribute('aria-current',String(active))});
this.load((i+1)%this.slides.length);
}
syncPause(){this.toggle.setAttribute('aria-pressed',String(this.paused));this.toggle.textContent=this.paused?this.toggle.dataset.play:this.toggle.dataset.pause}
schedule(){
clearTimeout(this.timer);clearTimeout(this.preload);
if(this.paused||this.hovered||this.focused||document.hidden||!this.visible||this.slides.length<2)return;
this.preload=setTimeout(()=>this.load((this.index+1)%this.slides.length),1500);
this.timer=setTimeout(async()=>{await this.show((this.index+1)%this.slides.length);this.schedule()},8000);
}
disconnectedCallback(){clearTimeout(this.timer);clearTimeout(this.preload);this.observer?.disconnect();document.removeEventListener('visibilitychange',this.onVisibility);this.ready=false}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etchedworks-product-main"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const price = section.querySelector('[data-product-price]');
    const sku = section.querySelector('[data-product-sku]');
    const variantRadios = section.querySelectorAll('[data-variant-radio]');



    const quoteLink = section.querySelector('[data-ew-quote-link]');

    variantRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        if (price) price.textContent = radio.dataset.price;
        if (sku) sku.textContent = radio.dataset.sku ? `SKU ${radio.dataset.sku}` : '';
        if (quoteLink) { const quoteUrl = new URL(quoteLink.href); quoteUrl.searchParams.set('variant', radio.value); quoteLink.href = quoteUrl.toString(); }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });


    const copyButton = section.querySelector('[data-copy-product-link]');
    const copyStatus = section.querySelector('[data-copy-status]');
    copyButton?.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(window.location.href); if (copyStatus) copyStatus.textContent = 'Link copied'; window.setTimeout(() => { if (copyStatus) copyStatus.textContent = ''; }, 2200); }
      catch (error) { if (copyStatus) copyStatus.textContent = 'Copy the page address from your browser'; }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
